export default __webpack_public_path__ + "static/media/Create-documentation.866c0d00.md";